const formatContent = (text, variables) =>
  Object.keys(variables).reduce((last, key) => {
    const regex = new RegExp(`%%${key}%%`, 'g')
    return last && last.replace(regex, variables[key])
  }, text)

export default formatContent
